import { render } from "./rightArrow.vue?vue&type=template&id=0da606b6"
import script from "./rightArrow.vue?vue&type=script&lang=js"
export * from "./rightArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__